module.exports = __webpack_public_path__ + "static/media/vu.c16a1a3e.svg";